import { createAction } from 'redux-actions'
import { SET_RESPONSES, CLEAR_RESPONSES } from './constants'

export const setAccessibilityResponses = createAction(SET_RESPONSES)
export const clearAccessibilityResponses = createAction(CLEAR_RESPONSES)
